import type { JSX } from 'react'
import type { ITabsProps } from 'blocks/Tabs'

import { Tabs } from 'blocks/Tabs'
import { BORDERS, COLOR, FIXED_INDENTS } from 'vars/index'

export interface ITabsWithBorder extends ITabsProps {}

export const TabsWithBorder = ({
  gap = FIXED_INDENTS.INDENT_10,
  children,
  paddings = [FIXED_INDENTS.INDENT_10],
  borderColor = COLOR.ACCENT_TERTIARY,
  borderWidth = BORDERS.BORDER_10,
  isFixedWidthTabs = true,
  ...rest
}: ITabsWithBorder): JSX.Element => {
  return (
    <Tabs
      paddings={paddings}
      borderColor={borderColor}
      borderWidth={borderWidth}
      gap={gap}
      isFixedWidthTabs={isFixedWidthTabs}
      {...rest}
    >
      {children}
    </Tabs>
  )
}
